export default __webpack_public_path__ + "static/media/full-logo.afcbaa41.svg";